

// general fnc

export const renderOptions = {
  renderText: (text) => {
    return text.split("\n").reduce((children, textSegment, index) => {
      return [...children, index > 0 && <br key={index} />, textSegment];
    }, []);
  },
};

export const justURLString = () => {
  const URLArray = String(window.location.href).split("?");

  let URLString = String(URLArray[0])
    .replace("http://", "")
    .replace("https://", "");

  return URLString;
};


export const validatePath = (path) => {
  const aURI = String(path).charAt(path.length -1);
  let uri = path;
  if (aURI === "/") {
    uri = uri.slice(0,-1);
  }
  return uri;
} 


// one click

export const OnLinkClick = (url, currentURL) => {
  // console.log(url, currentURL);


 if (String(url).indexOf("onelink") === -1) {
   window.open(url, "_blank");
   return
 }

  var oneLinkURL = url;
  var mediaSource = { keys: ["utm_source"], defaultValue: "Discovery-Web" };
  // var campaign = {keys:["utm_campaign"],defaultValue:"(not%20set)"+"_Discovery-Web", overrideValues:{"campaign": "nwcampain"}}; //default actual URL
  // var campaign = {keys:["utm_campaign"],defaultValue:urlData+"_Discovery-Web"}; //default actual URL
  var campaign = { keys: ["utm_campaign"], defaultValue: "Discovery-Web" }; //default actual URL
  var ad = { keys: ["utm_content"], defaultValue: "(not%20set)" };
  var adSet = { keys: ["utm_term"], defaultValue: "Discovery-Web" };
  var channel = { keys: ["utm_channel"], defaultValue: currentURL }; // check with client about parameterg
  var googleClickIdKey = "af_sub1";
  var custom_ss_ui = { paramKey: "af_ss_ui", defaultValue: "true" };

  var urlParams = new URLSearchParams(window.location.search);
  var utmCampaignValue = urlParams.get("utm_campaign");

  if (utmCampaignValue) {
    campaign.overrideValues = {
      [utmCampaignValue.toString()]:
        utmCampaignValue.toString() + "_Discovery-Web",
    }; //utmCampaignValue + "_Discovery-Web";
  }

  //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
  //Onelink URL is generated.

  var result = window.AF_SMART_SCRIPT.generateOneLinkURL({
    oneLinkURL: oneLinkURL,
    afParameters: {
      mediaSource: mediaSource,
      campaign: campaign,
      ad: ad,
      channel: channel,
      adSet: adSet,
      googleClickIdKey: googleClickIdKey,
      afCustom: [custom_ss_ui],
    },
  });

  console.log("result smartLink", result);

  if (result) {
    window.open(result.clickURL, "_blank");
  }
};


export const getPageData = (query) => {
  return new Promise((resolve, reject) => {
    window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authenticate the request
          Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
        },
        // send the GraphQL query
        body: JSON.stringify({ query }),
      })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error("erros", errors);
          reject(errors);
        }
        resolve(data)
      });
  });
};
